import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from "@mui/material";

function MessageDialog({
  open,
  title = "Message",
  content = "This is a message?",
  cancelText = "Ok",
  onCancel
}) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth disableRestoreFocus>
      {title && <DialogTitle>{title}</DialogTitle>}
      <DialogContent>
        {typeof content === "string" ? (
          <Typography>{content}</Typography>
        ) : (
          content
        )}
      </DialogContent>
      <DialogActions>
        <>
          <div style={{flex: '1 0 0'}} />
          <Button onClick={onCancel} color="primary">
            {cancelText}
          </Button>
        </>
      </DialogActions>
    </Dialog>
  );
}

export default MessageDialog;